import ConstData from "../ConstData";
import { enTokenCMD } from "../classTalk/CodeEnum";
import { checkDownloadableUrl } from "../func/ExportFunction";

import {
    getMySmallGroupSendKey
} from "../RabbitmqClient";

/**
 * Pbl 모드 Pentalk WiFi에서 Pentalk Pro 서버에 업로드한 파일을
 * Pentalk WiFi에서 다운로드할 수 있는 파일 다운로드 URL로 변환하여 전달해야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {String} pathData - 업로드한 파일을 다운로드할 수 있는 URL
 * @param {String} filename - 확장자가 포함된 업로드한 파일 이름
 * @param {String} userNickname - 사용자 이름
 * @since 2025-08-13.
 * @modify 2026-01-07.
 */
export const rcvFileShareResultHelper = (pathData, filename, userNickname) => {
    console.log("rcvFileShareResultHelper - pathData[", pathData, "]");

    let url = pathData;
    if (!checkDownloadableUrl(url)) {
        console.log("/download/ 포함되지 않은 url임 ... url => ", url);
        url = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + pathData;
    } else {
        url = pathData;
    }
    console.log("rcvFileShareResultHelper - Final download url => ", url);

    /* // 먼저 opener에 전달!
    if (window.opener) {
        if (typeof window.opener.rcvFileShareResult === "function") {
            window.opener.rcvFileShareResult(url);
        } else {
            console.log("rcvFileShareResultHelper - window.opener.rcvFileShareResult is not a function!!!");
        }
    } else {
        console.log("rcvFileShareResultHelper - window.opener is => ", window.opener);
    } */

    // let store = window.hiclasstv.store;
    // const { user } = store.getState();
    // const { userNickname } = user;
    console.log("rcvFileShareActionResultHelper - userNickname => ", userNickname);

    // c#에도 전달!
    const sendEvent = "upload";
    const sendData = JSON.stringify({ msg: url, filename, nick: userNickname });

    sendToBrowserData("sendFileData", JSON.stringify({ event: sendEvent, data: sendData }), "");
}

/**
 * Pentalk WiFi C#에서 클래스톡으로 파일을 공유할 경우
 * Pro 형식에 맞게 Rest API를 요청하기 위해
 * 필요한 정보를 반환하는 것을 돕는 Helper 메서드
 * 
 * @param {String} fileName - 전달할 파일 이름
 * @param {String} nickname - 전달할 사용자 닉네임
 * @returns {JSON} 파일 공유 정보 데이터
 * @since 2026-01-27.
 */
export const getSendChatFileShareDataHelper = (fileName, nickname) => {
    let mode = "whisper"; // 20260107 수정 ... Pentalk WiFi Pbl에서는 귓속말로만 전송해야함 ... by hjkim

    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    // const { classTalkLive } = store.getState();
    const { userSeq } = user;
    const { isMixedClassMember, performLiveInfo } = live;
    const { liveSeq, teacher_info, mixedClassStatus } = performLiveInfo;
    // const { isWhisperModalOpened, web_isWhisper } = classTalkLive;
    const teacherSeq = teacher_info.userSeq;

    let userNickname = nickname ? nickname : "";
    if (userNickname === "") {
        console.log("getSendChatFileShareDataHelper - Need to get the user nickname from store.getState().");
        // const { userNickname } = user;
        userNickname = user.userNickname;
    }
    console.log("getSendChatFileShareDataHelper - final userNickname => ", userNickname);

    let sendData = {
        mode: "web",
        command: enTokenCMD.ct_UploadAndShareFiles,
        filename: fileName,
        teacherSeq,
        liveSeq,
        userSeq,
        userNickname,
        isWhisper: true,
        whisperYN: "Y",
        smallGroupKey: getMySmallGroupSendKey(),
        isMixedClassMember,
        mixedClassStatus,
        kind: "pbl-content"
    };

    if (isMixedClassMember) {
        const { mixedClassInfo } = live;

        sendData = {
            ...sendData,
            localServerSeq: mixedClassInfo.localServerSeq,
            localLiveSeq: mixedClassInfo.localLiveSeq,
            localTeacherSeq: mixedClassInfo.localTeacherSeq
        };
    }

    console.log("getSendChatFileShareDataHelper - final sendData => ", sendData);

    return sendData;
}

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 전달해야 하는 경우
 * C#의 eoapi를 통해 전달하도록 돕는 Helper 메서드
 * 
 * @param {String} func - 메서드 명
 * @param {String} data1 - 전달할 데이터 1
 * @param {String} data2 - 전달할 데이터 2
 * @since 2025-08-13.
 */
const sendToBrowserData = (func, data1, data2) => {
    if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke(func, [data1, data2]);
    }
}